module.exports = __webpack_public_path__ + "static/img/btn_1.145b837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/btn_1.png
// module id = A/J9
// module chunks = 1 3